import * as React from 'react';

import { ICardDetailsStack } from '../interfaces';

interface IProps {
  id?: string;
  cardInfo: ICardDetailsStack;
  scrollStyles?: React.CSSProperties;
  forwardedRef?: React.RefObject<HTMLDivElement>;
  textStyle?: string;
}

function MonetizeStackCard(props: IProps) {
  const {
    id,
    cardInfo: { title, color },
    scrollStyles,
    forwardedRef,
    textStyle,
  } = props;

  return (
    <div
      id={id}
      data-qa={id}
      ref={forwardedRef}
      className={`home-page__monetize-stack-card home-page__monetize-stack-card-${color}`}
      style={scrollStyles}
    >
      <p className={`home-page__monetize-stack-card-text ${textStyle ? textStyle : ''}`}>{title}</p>
    </div>
  );
}

export { MonetizeStackCard };
